import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLightbulbIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 20,
	viewBox: "0 0 22 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19.0642 3.7327L17.7181 2.38663L16.0093 4.10501L17.3553 5.45107L19.0642 3.7327ZM11.952 2.86396H10.0427V0H11.952V2.86396ZM21.4985 11.4558H18.6346V9.54654H21.4985V11.4558ZM10.0427 18.0907V14.3103L9.08803 13.7566C7.90426 13.0692 7.17873 11.8091 7.17873 10.4535C7.17873 8.34368 8.88756 6.63485 10.9973 6.63485C13.1071 6.63485 14.816 8.34368 14.816 10.4535C14.816 11.8091 14.0809 13.0692 12.9066 13.7566L11.952 14.3103V18.0907H10.0427ZM8.13338 20H13.8613V15.4081C15.5701 14.4153 16.7253 12.5728 16.7253 10.4535C16.7253 7.29356 14.1572 4.72554 10.9973 4.72554C7.83744 4.72554 5.26942 7.29356 5.26942 10.4535C5.26942 12.5728 6.42455 14.4153 8.13338 15.4081V20ZM3.36011 11.4558H0.496149V9.54654H3.36011V11.4558ZM5.99496 4.09547L4.28613 2.37709L2.94006 3.72315L4.65844 5.43198L5.99496 4.09547Z",
		fill: "#BFD2DB"
	})
});
export default SvgLightbulbIcon;
